import { AudioData, AudioPlayer } from "./AudioPlayer";
import { LoaderFileKeys } from "../app/constant/AppConstants";
import { OptionsItemThemeData, OptionsItemThemeItemSoundData } from "../types/types";
import { ThemeDataManager } from "../app/managers/ThemeDataManager";


export enum SoundEffectKeys {
    dealXS1 = "dealXS1",
    dealXS2 = "dealXS2",
    dealXS3 = "dealXS3",
    dealXS4 = "dealXS4",
    dealXS5 = "dealXS5",
    dealXS6 = "dealXS6",
    dealXS7 = "dealXS7",
    dealXS8 = "dealXS8",
    dealM1 = "dealM1",
    fanoutXL1 = "fanoutXL1",
    fanoutXL2 = "fanoutXL2",
    dealM2 = "dealM2",
    dealM3 = "dealM3",
    dealS1 = "dealS1",
    dealS2 = "dealS2",
    dealS3 = "dealS3",
    shuffleS1 = "shuffleS1",
    dropS1 = "dropS1",
    dropS2 = "dropS2",
    dropM1 = "dropM1",
    drawS1 = "drawS1",
    drawS2 = "drawS2",
    drawL1 = "drawL1",
    shuffleXXL1 = "shuffleXXL1",
    drawS3 = "drawS3",
    drawS4 = "drawS4",
    drawS5 = "drawS5",
    drawS6 = "drawS6",
    drawS7 = "drawS7",
    drawS8 = "drawS8",
    drawS9 = "drawS9",
    drawS10 = "drawS10",
    multiDropM1 = "multiDropM1",
    multiDropL1 = "multiDropL1",
    multiDropXL1 = "multiDropXL1",
    click1 = "click1",
    tearDrop1 = "tearDrop1",
    click2 = "click2",
    win1 = "win1",
    win2 = "win2",
    win3 = "win3",
    win4 = "win4",
    win5 = "win5",
    win6 = "win6",
    win7 = "win7",
    loss1 = "loss1",
    click3 = "click3",
    click4 = "click4",
    click5 = "click5",
    click6 = "click6",
    click7 = "click7",
    click8 = "click8",
    click9 = "click9",
}

/**
 * Custom app-specific extension to the ubiquitous @see AudioPlayer
 * > contains data model
 * > app specific method calls
 */
export class AppAudioPlayer extends AudioPlayer
{
    public tracks: string[];
    private static gameSettings_json: any;


    public static override Init(scene:Phaser.Scene): void
    {
        super.Init(scene);
        // this.gameSettings_json = this.scene.cache.json.get(LoaderFileKeys.gameSettings_json);
    }

    /**
     * Register all music tracks, sounds etc. 
     * Load appropriate sounds as well.
     * Play appropriate background music track.
     */
    public static Build(): void
    {
        // add audio data for all music tracks
        const musicThemeData:OptionsItemThemeData = ThemeDataManager.GetOptionsItemThemeDataByItemId("musicTrack");
        for (let i:number=0; i<musicThemeData.items.length; i++) {
            const soundData:OptionsItemThemeItemSoundData = musicThemeData.items[i].sound;
            const trackData: AudioData = {
                key: "musicTrack" + i,
                urls: soundData.urls,
                soundConfig: soundData.config
            }
            // console.log(trackData);
            AppAudioPlayer.AddMusicTrackData(trackData);
        }
    }
    
    public static PlaySfx(key: SoundEffectKeys): void
    {
        // console.log(key);
        
        if (this.isSoundsEnabled) {
            this.scene.sound.playAudioSprite(LoaderFileKeys.sfx, key);
        }
    }
    
    public static PlaySfxRandomFromCollection(keys: SoundEffectKeys[]): void
    {
        if (this.isSoundsEnabled) {
            const key: SoundEffectKeys = Phaser.Utils.Array.GetRandom(keys);
            // console.log(keys.indexOf(key), key);
            this.scene.sound.playAudioSprite(LoaderFileKeys.sfx, key);
        }
    }
}